module.exports = __webpack_public_path__ + "static/media/Picture73.ed73e94a.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture73.PNG
// module id = 1537
// module chunks = 0